import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { BalanceSyncService } from './balance-sync.service';

@Injectable()
export class BalanceSyncInterceptor implements HttpInterceptor {
  private readonly mutationMethods = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);
  private readonly trackedUrlFragments = [
    '/business/caissier/prelever/somme/achat/du/compte/client',
    '/business/caissier/depot/sur/compte/client',
    '/business/caissier/retrait/sur/compte/client',
    '/business/transfert/vers/solde/initial',
    '/primary/account/transactions/transfert/vers/compte/primaire',
    '/primary/account/transactions/transfert/vers/compte/affaire',
    '/utilisateur/partenaire/depot/sur/compte/primaire/client/net',
    '/utilisateur/partenaire/depot/sur/compte/bussness/client/net',
    '/utilisateur/partenaire/retrait/sur/compte/primaire/client/net',
    '/utilisateur/partenaire/retrait/sur/compte/bussness/client/net',
    '/online/purchase',
    '/online/subscription/pay',
    '/business/facturation/make/transfert',
    '/utilisateur/partenaire/facturation/make/tranfert'
  ];

  constructor(private balanceSyncService: BalanceSyncService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.shouldTrack(req)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (!(event instanceof HttpResponse)) {
          return;
        }

        if (!this.isSuccessBody(event.body)) {
          return;
        }

        this.balanceSyncService.syncNow().pipe(take(1)).subscribe({
          error: () => {
            // No-op: on ne bloque jamais la réponse utilisateur
          }
        });
      })
    );
  }

  private shouldTrack(req: HttpRequest<any>): boolean {
    if (!this.mutationMethods.has(req.method.toUpperCase())) {
      return false;
    }

    const url = req.url.toLowerCase();
    if (url.includes('/spay/auth/login') || url.includes('/spay/auth/refresh')) {
      return false;
    }

    return this.trackedUrlFragments.some(fragment => url.includes(fragment));
  }

  private isSuccessBody(body: any): boolean {
    if (body === null || body === undefined || body === '') {
      return true;
    }

    if (typeof body === 'number') {
      return body === 0;
    }

    if (typeof body === 'boolean') {
      return body;
    }

    if (typeof body === 'object') {
      if (typeof body.code === 'number') {
        return body.code === 0;
      }
      if (typeof body.success === 'boolean') {
        return body.success;
      }
      return true;
    }

    return true;
  }
}
